import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork, UtilityService } from 'src/app/core/core.module';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';
import { DialogService } from 'src/app/shared/dialog.service';

@Component({
    selector: 'app-customer-invoices-dialog',
    templateUrl: './customer-invoices-dialog.component.html',
    styleUrls: ['./customer-invoices-dialog.component.scss'],
    imports: [DevExtremeModule]
})
export class CustomerInvoicesDialogComponent extends BaseDialogComponent<any> implements OnInit {
    customerId: number;
    startDate: Date;
    endDate: Date;
    invoices: any[];

    constructor(
        private uow: CdrUnitOfWork,
        private dialogService: DialogService,
        private authService: AuthService,
        private appInfo: AppInformationService,
        private utilityService: UtilityService
    ) {
        super();
    }

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.invoices = await this.uow.getInvoicesByCustomer(this.customerId, this.startDate, this.endDate);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            }
        );
    }
}
